import {
	boostCheckoutResponseSchema,
	boostPricingSchema,
	boostStatusSchema,
} from "../../schemas/finance";
import { fetchApi } from "../client/internal";

export const boosts = {
	getPricing: (clubId: string) => fetchApi(`/${clubId}/boosts/pricing`, boostPricingSchema),
	getStatus: (clubId: string) => fetchApi(`/${clubId}/boosts`, boostStatusSchema),
	createCheckout: (clubId: string, durationDays: number) =>
		fetchApi(`/${clubId}/boosts`, boostCheckoutResponseSchema, {
			method: "POST",
			body: JSON.stringify({ duration_days: durationDays }),
		}),
};
